import React from 'react';

/** Canada's Top Growing Companies promo banner — disabled site-wide. */
export const CTGCBanner: React.FunctionComponent = () => null;
